import axios from "axios";
import { StandardAxiosConfig, getCompressed, Filter, getBaseDataURL, parseDates } from "../../../common";
import { BaseDataModel } from "../../../../models";

export class GetAPI_Base<T extends BaseDataModel> {
	protected baseUrl: string;
	private isCompressed: boolean = false;

	constructor(router: string, isCompressed: boolean = false) {
		this.baseUrl = `${getBaseDataURL(router)}/get`;
		this.isCompressed = isCompressed;
	}

	public async all(): Promise<T[]> {
		return this.byFilter();
	}

	public async byFilter(filter: Filter<T> = { fields: [] } as Filter<T>): Promise<T[]> {
		const url = `${this.baseUrl}${this.isCompressed ? "?compressed=true" : ""}`;

		if (this.isCompressed) {
			const records = (await getCompressed(url, filter)) as T[];
			parseDates<T>(records);
			return records;
		} else {
			const response = await axios.post(url, filter, StandardAxiosConfig());
			const records = response.data as T[];
			parseDates<T>(records);
			return records;
		}
	}

	public async byIds(ids: string[]): Promise<T[]> {
		const filter = {
			type: "OR",
			fields: ids.map((id) => ({ id: id })),
		} as Filter<T>;

		const records = await this.byFilter(filter);
		parseDates<T>(records);
		return records;
	}

	public async byId(id: string, isCompressed: boolean = this.isCompressed): Promise<T> {
		const queryParams: string[] = [];
		if (isCompressed) queryParams.push(`compressed=true`);
		const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

		const url = `${this.baseUrl}/${id}${queryString}`;

		if (isCompressed) {
			const record = await getCompressed(url);
			if (Array.isArray(record)) {
				const r = record[0] as T;
				parseDates<T>([r]);
				return r;
			} else {
				const r = record as T;
				parseDates<T>([r]);
				return r;
			}
		} else {
			const response = await axios.get(url, StandardAxiosConfig());
			const record = response.data as T;
			parseDates<T>([record]);
			return record;
		}
	}
}
